import axios from "axios";
import Config from "./config";

const $axios = axios.create({
    baseURL: Config.END_POINT
});

$axios.interceptors.request.use(request => {
    let { token } = JSON.parse(localStorage.getItem("user") || "{}");
    request.headers.Authorization = `Bearer ${token}`;
    return request;
});

export default $axios;
